export default "__VITE_ASSET__x2YqHgKS__"